module.exports = __webpack_public_path__ + "img/tussam_hero_card.08ae6598.png";